// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyText_wrap__kOYkx"};